import { Actions, ActionTypes } from './settings.action';
import { SettingsReducer } from './settings.model';

export const INITIAL_STATE: SettingsReducer = {
  activeAlertsSubService: '',
};

export function settingsReducer(state = INITIAL_STATE, action: Actions) {
  switch (action.type) {
    case ActionTypes.SET_ACTIVE_ALERTS_SUB_SERVICE:
      return {
        ...state,
        activeAlertsSubService: action.payload,
      };
    default:
      return state;
  }
}
